import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

const App = () => (
            <SwaggerUI
                spec={{
                                "openapi": "3.0.2",
                                "info": {
                                    "title": "Abbonamento Musei API",
                                    "description":
                                            "Le API di Abbonamento Musei consentono di esplorare i dati messi a disposizione da Abbonamento Musei riguardo ad Eventi, Notizie, Mostre, Spazi Espositivi e Luoghi di Spettacolo per le regioni Piemonte, Lombardia e Valle d'Aosta.\n\n**Servizi accessibilità:**\n\n- `audioguide_lis_is`: Audioguida in LIS e in IS\n- `museo_accessibile`: Museo accessibile a persone con disabilità\n- `tariffa_ingresso_dedicata`: Tariffa d'ingresso dedicata ai disabili\n- `tariffa_scontata`: Tariffa d'ingresso dedicata all'accompagnatore\n- `mezzi_pubblici`: Museo raggiungibile con mezzi pubblici\n- `fermate_accessibili`: Presenza di fermate accessibili dei mezzi pubblici nei pressi del museo\n- `stalli_per_parcheggio`: Presenza degli stalli per il parcheggio delle persone con disabilità\n- `museo_accessibile_disabile_motorio`: Museo accessibile al disabile motorio\n- `ingresso_alternativo`: Presenza di un ingresso alternativo per i disabili\n- `campanello`: Ingresso per i disabili dotato di campanello\n- `percorsi_museali_dedicati`: Percorsi museali dedicati\n- `ascensore`: Museo dotato di ascensore\n- `braille`: Ascensore dotato di pulsantiera in Braille\n- `ascensore_vocale`: Ascensore dotato di annuncio vocale del piano\n- `uscite_di_sicurezza`: Museo dotato di uscite di sicurezza utilizzabili dai disabili motori\n- `informazioni_pericolo`: Impianti visivi o acustici per la comunicazione di informazioni in situazioni di pericolo\n- `servizi_del_museo`: Servizi del museo\n- `servizi_igienici`: Servizi igienici dedicati per le persone con disabilità\n- `audioguide`: Audioguide o supporti alla visita appositamente pensati per persone con disabilità\n\n**Servizi infanzia:**\n\n- `accessibilita_interna`: Accessibilità all'interno del museo\n- `accessibilita_esterna`: Accessibilità per entrare nel museo\n- `allattamento`: Area allattamento\n- `kit_famiglie`: Kit famiglie da utilizzare durante il percorso di visita\n- `passeggino`: Passeggino disponibile all'ingresso\n- `fascia`: Fascia / Zaino porta bimbi\n- `parcheggio`: Parcheggio passeggini\n- `fasciatoio`: Fasciatoio\n- `alzatine`: Alzatine\n- `wc`: Rialzi WC\n- `scaldavivande`: Scaldabiberon / Scaldavivande / Posateria dedicata\n- `menu`: Menu (variazioni ad hoc per bambini)\n- `seggiolone`: Seggiolone / riduttore sedia\n- `tappetini`: Tappetini\n- `relax`: Area di decompressione / relax\n- `prima_infanzia`: Area dedicata per attività prima infanzia\n- `materiali_prima`: Materiali per preparare la visita\n- `materiali_durante`: Materiali dedicati da utilizzare durante la visita\n- `materiali_dopo`: Materiali da conservare dopo la visita\n- `orari_famiglie`: Fasce orarie suggerite per famiglie\n- `biglietto`: Biglietto di ingresso applicato dopo il 1° anno del bambino (o formula famiglia)\n- `attivita_speciali`: Attività speciali: laboratori, workshop, visite dinamiche\n\n**ATTENZIONE**: Nel caso in cui l'attributo 'orari' o 'aperture_chiusure_straordinarie' di oggetti di tipo Evento o Mostre non sia presente dovranno essere considerati, ove presenti, i corrispondenti attributi dell'oggetto SpazioEspositivo contenuti negli oggetti stessi.",
                                    "version": "1.2.0",
                                },
                                "servers": [
                                    {
                                        "url": "https://api.abbonamentomusei.it",
                                    },
                                ],
                                "tags": [
                                    {"name": "notizie", "description": "Gestione notizie"},
                                    {"name": "eventi", "description": "Gestione eventi"},
                                    {"name": "mostre", "description": "Gestione mostre temporanee"},
                                    {"name": "spazioEspositivo", "description": "Gestione spazi espositivi (musei)"},
                                    {"name": "luogoSpettacolo", "description": "Gestione luoghi di spettacolo"},
                                    {"name": "categoria", "description": "Categorie di luoghi e spazi"},
                                    {"name": "provincia", "description": "Province delle regioni"},
                                    {"name": "puntiVendita", "description": "Punti vendita abbonamenti"},
                                    {"name": "search", "description": "Ricerca unificata"},
                                    {"name": "homepage", "description": "Contenuti in evidenza per homepage"},
                                ],
                                "paths": {
                                    "/am/notizie": {
                                        "get": {
                                            "tags": ["notizie"],
                                            "summary": "Elenco paginato delle notizie",
                                            "description": "Restituisce l'elenco paginato delle notizie in ordine decrescente rispetto alla data di pubblicazione (wp_date). Supporta filtri per posizione geografica e ricerca testuale.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "wp_date"},
                                                    "description": "Campo per ordinamento",
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"]},
                                                    "description": "Ordinamento ascendente (1) o discendente (0)",
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Testo di ricerca",
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number", "format": "double"},
                                                    "description": "Latitudine per ricerca geografica",
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number", "format": "double"},
                                                    "description": "Longitudine per ricerca geografica",
                                                },
                                                {
                                                    "name": "distance",
                                                    "in": "query",
                                                    "schema": {"type": "number", "format": "double", "default": 1},
                                                    "description": "Distanza in km per ricerca geografica",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco notizie",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "total": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Notizia"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/notizie/{id}": {
                                        "get": {
                                            "tags": ["notizie"],
                                            "summary": "Dettaglio notizia",
                                            "description": "Restituisce i dettagli della notizia specificata",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                    "description": "WordPress ID della notizia",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio notizia",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/Notizia"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/eventi": {
                                        "get": {
                                            "tags": ["eventi"],
                                            "summary": "Elenco paginato degli eventi",
                                            "description": "Restituisce l'elenco paginato degli eventi futuri con le loro occorrenze (date_evento). Ogni evento può avere multiple date. Supporta filtri per provincia, regione, data, AM Club e ricerca testuale.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "provincia",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "regione",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                },
                                                {
                                                    "name": "data_da",
                                                    "in": "query",
                                                    "schema": {"type": "string", "format": "date"},
                                                    "description": "Data inizio filtro (YYYYMMDD)",
                                                },
                                                {
                                                    "name": "data_a",
                                                    "in": "query",
                                                    "schema": {"type": "string", "format": "date"},
                                                    "description": "Data fine filtro (YYYYMMDD)",
                                                },
                                                {
                                                    "name": "amclub",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"]},
                                                    "description": "Filtra eventi AM Club",
                                                },
                                                {
                                                    "name": "show_tela",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"]},
                                                    "description": "Mostra/nascondi eventi Athena",
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "distance",
                                                    "in": "query",
                                                    "schema": {"type": "number", "default": 1},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco eventi",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Evento"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/eventi/{id}": {
                                        "get": {
                                            "tags": ["eventi"],
                                            "summary": "Dettaglio evento",
                                            "description": "Restituisce i dettagli dell'evento con tutte le sue occorrenze future",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                    "description": "WordPress ID dell'evento",
                                                },
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore (tessera_piemonte_vda, tessera_lombardia_vda, tessera_extra), slug con trattino (tessera-piemonte-valle-daosta, tessera-lombardia-valle-daosta, tessera-extra) oppure id_prodotto Netcaring (99, 101, 167)",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio evento",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/Evento"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/mostre": {
                                        "get": {
                                            "tags": ["mostre"],
                                            "summary": "Elenco paginato delle mostre temporanee",
                                            "description": "Restituisce l'elenco paginato delle mostre temporanee future ordinate per data_inizio. Supporta filtri per provincia, regione, date e ricerca testuale.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "provincia",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "regione",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                },
                                                {
                                                    "name": "data_da",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Data inizio filtro (YYYYMMDD)",
                                                },
                                                {
                                                    "name": "data_a",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Data fine filtro (YYYYMMDD)",
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "data_inizio,data_fine"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"]},
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "distance",
                                                    "in": "query",
                                                    "schema": {"type": "number", "default": 1},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco mostre",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Mostra"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/mostre/{id}": {
                                        "get": {
                                            "tags": ["mostre"],
                                            "summary": "Dettaglio mostra",
                                            "description": "Restituisce i dettagli della mostra. Se fornito subscription_type, include i campi in_abbonamento, in_sconto e abbonamento calcolati in base al tipo di tessera.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                    "description": "WordPress ID della mostra",
                                                },
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore (tessera_piemonte_vda, tessera_lombardia_vda, tessera_extra), slug con trattino (tessera-piemonte-valle-daosta, tessera-lombardia-valle-daosta, tessera-extra) oppure id_prodotto Netcaring (99, 101, 167). Può essere multiplo separato da virgola.",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio mostra",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/Mostra"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/spazi_espositivi": {
                                        "get": {
                                            "tags": ["spazioEspositivo"],
                                            "summary": "Elenco paginato degli spazi espositivi",
                                            "description": "Restituisce l'elenco paginato degli spazi espositivi (musei) ordinati alfabeticamente. Include l'eventuale mostra permanente.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "title"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"], "default": "1"},
                                                },
                                                {
                                                    "name": "provincia",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "regione",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "distance",
                                                    "in": "query",
                                                    "schema": {"type": "number", "default": 1},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco spazi espositivi",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/spazi_espositivi/{id}": {
                                        "get": {
                                            "tags": ["spazioEspositivo"],
                                            "summary": "Dettaglio spazio espositivo",
                                            "description": "Restituisce i dettagli dello spazio espositivo. Se fornito subscription_type e lo spazio ha una mostra, calcola i campi in_abbonamento/in_sconto per la mostra.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                    "description": "WordPress ID dello spazio espositivo",
                                                },
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento per calcolo vantaggi mostra: slug con underscore (tessera_piemonte_vda, tessera_lombardia_vda, tessera_extra), slug con trattino (tessera-piemonte-valle-daosta, tessera-lombardia-valle-daosta, tessera-extra) oppure id_prodotto Netcaring (99, 101, 167)",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio spazio espositivo",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/spazi_espositivi/{id}/mostre": {
                                        "get": {
                                            "tags": ["spazioEspositivo"],
                                            "summary": "Mostre temporanee di uno spazio espositivo",
                                            "description": "Restituisce l'elenco paginato delle mostre temporanee future associate allo spazio espositivo specificato. Supporta gli stessi filtri dell'endpoint /am/mostre.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                    "description": "WordPress ID dello spazio espositivo",
                                                },
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "data_inizio,data_fine"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"]},
                                                },
                                                {
                                                    "name": "data_da",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Data inizio filtro (YYYYMMDD)",
                                                },
                                                {
                                                    "name": "data_a",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Data fine filtro (YYYYMMDD)",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco mostre",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Mostra"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/musei_athena/{id}": {
                                        "get": {
                                            "tags": ["spazioEspositivo"],
                                            "summary": "Dettaglio spazio espositivo per ID Athena",
                                            "description": "Restituisce i dettagli dello spazio espositivo identificato dall'ID agenzia Athena",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                    "description": "ID agenzia Athena",
                                                },
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore, slug con trattino o id_prodotto Netcaring. Vedi /am/eventi/{id} per i valori accettati.",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio spazio espositivo",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/luoghi": {
                                        "get": {
                                            "tags": ["luogoSpettacolo"],
                                            "summary": "Elenco paginato dei luoghi di spettacolo",
                                            "description": "Restituisce l'elenco paginato dei luoghi di spettacolo ordinati alfabeticamente",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "data_evento"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"], "default": "1"},
                                                },
                                                {
                                                    "name": "provincia",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "regione",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "distance",
                                                    "in": "query",
                                                    "schema": {"type": "number", "default": 1},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco luoghi",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/LuogoSpettacolo"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/luoghi/{id}": {
                                        "get": {
                                            "tags": ["luogoSpettacolo"],
                                            "summary": "Dettaglio luogo di spettacolo",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio luogo",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/LuogoSpettacolo"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/categories": {
                                        "get": {
                                            "tags": ["categoria"],
                                            "summary": "Elenco categorie",
                                            "description": "Restituisce l'elenco delle categorie di luoghi e spazi espositivi ordinato alfabeticamente",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "label"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"], "default": "1"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco categorie",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "array",
                                                                "items": {"$ref": "#/components/schemas/Categoria"},
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/province": {
                                        "get": {
                                            "tags": ["provincia"],
                                            "summary": "Elenco province",
                                            "description": "Restituisce l'elenco delle province, opzionalmente filtrate per regione",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "regione",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Filtra per regioni (separatore virgola). Es: piemonte,lombardia",
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "label"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"], "default": "1"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco province",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "array",
                                                                "items": {"$ref": "#/components/schemas/Provincia"},
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/punti_vendita": {
                                        "get": {
                                            "tags": ["puntiVendita"],
                                            "summary": "Elenco punti vendita",
                                            "description": "Restituisce l'elenco paginato dei punti vendita abbonamenti",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 10000},
                                                    "description": "Numero di risultati per pagina",
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "title"},
                                                },
                                                {
                                                    "name": "ascending",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["0", "1"], "default": "1"},
                                                },
                                                {
                                                    "name": "provincia",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "regione",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "distance",
                                                    "in": "query",
                                                    "schema": {"type": "number", "default": 1},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Elenco punti vendita",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/PuntoVendita"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/punti_vendita/{id}": {
                                        "get": {
                                            "tags": ["puntiVendita"],
                                            "summary": "Dettaglio punto vendita",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "id",
                                                    "in": "path",
                                                    "required": true,
                                                    "schema": {"type": "integer"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Dettaglio punto vendita",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {"$ref": "#/components/schemas/PuntoVendita"},
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                                "404": {"$ref": "#/components/responses/NotFound"},
                                            },
                                        },
                                    },
                                    "/am/search": {
                                        "get": {
                                            "tags": ["search"],
                                            "summary": "Ricerca unificata",
                                            "description": "Endpoint di ricerca unificata che supporta tre modalità:\n\n**1. TEXT SEARCH** (search_type=text): Ricerca testuale su mostre, eventi e musei con mix editoriale e paginazione per slot (ogni evento conta per le sue occorrenze future).\n\n**2. FILTERS** (search_type=filters o default): Ricerca per filtri con tre sottotipi:\n- `filter_item_type=all`: Mix editoriale di eventi/mostre/musei con paginazione per slot\n- `filter_item_type=exhibition`: Solo mostre temporanee\n- `filter_item_type=event`: Solo eventi con paginazione per occorrenze\n- `filter_item_type=museum`: Solo musei\n\n**3. DEFAULT**: Equivalente a FILTERS.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "search_type",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["text", "filters", "default"], "default": "filters"},
                                                    "description": "Tipo di ricerca",
                                                },
                                                {
                                                    "name": "page",
                                                    "in": "query",
                                                    "schema": {"type": "integer", "default": 0},
                                                    "description": "Numero di pagina (0-based)",
                                                },
                                                {
                                                    "name": "size",
                                                    "in": "query",
                                                    "schema": {"type": "integer"},
                                                    "description": "Numero di risultati per pagina. Default: 20 per filter_item_type=all e per search_type=text; illimitato (10000) per exhibition/event/museum.",
                                                },
                                                {
                                                    "name": "order",
                                                    "in": "query",
                                                    "schema": {"type": "string", "default": "data_evento"},
                                                    "description": "Campo di ordinamento. Compatibilita' con versioni precedenti: ignorato se non applicabile al ramo selezionato.",
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Testo di ricerca (solo per search_type=text)",
                                                },
                                                {
                                                    "name": "filter_item_type",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["all", "exhibition", "event", "museum"], "default": "all"},
                                                    "description": "Tipo di item da cercare (solo per search_type=filters/default)",
                                                },
                                                {
                                                    "name": "filter_province",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Province separate da virgola",
                                                },
                                                {
                                                    "name": "filter_region",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Regioni separate da virgola (piemonte,lombardia,valle-aosta)",
                                                },
                                                {
                                                    "name": "id_athena",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "ID Athena separati da virgola (solo per musei)",
                                                },
                                                {
                                                    "name": "filter_exhibition_am_option",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["all", "by_subscription", "on_sale"], "default": "all"},
                                                    "description": "Filtro mostre per abbonamento (solo per filter_item_type=exhibition)",
                                                },
                                                {
                                                    "name": "filter_exhibition_time",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["ongoing", "future"]},
                                                    "description": "Filtro temporale mostre: ongoing=in corso, future=future (solo per filter_item_type=exhibition)",
                                                },
                                                {
                                                    "name": "filter_event_am_option",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["all", "am_club", "am_family"], "default": "all"},
                                                    "description": "Filtro eventi AM (solo per filter_item_type=event)",
                                                },
                                                {
                                                    "name": "filter_event_time",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Mese filtro eventi (YYYY/MM/DD o YYYYMMDD) - solo per filter_item_type=event",
                                                },
                                                {
                                                    "name": "filter_museum_am_option",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Categorie musei separate da virgola (slug) - solo per filter_item_type=museum",
                                                },
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento per calcolo vantaggi: slug con underscore (tessera_piemonte_vda, tessera_lombardia_vda, tessera_extra), slug con trattino (tessera-piemonte-valle-daosta, tessera-lombardia-valle-daosta, tessera-extra) oppure id_prodotto Netcaring (99, 101, 167)",
                                                },
                                                {
                                                    "name": "random_seed",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Seed per randomizzazione (default: YYYYMMDDHH corrente)",
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Risultati ricerca",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer", "description": "Totale slot (eventi contano per le loro occorrenze)"},
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "oneOf": [
                                                                                {"$ref": "#/components/schemas/Evento"},
                                                                                {"$ref": "#/components/schemas/Mostra"},
                                                                                {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                                            ],
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/search/count": {
                                        "get": {
                                            "tags": ["search"],
                                            "summary": "Conteggio risultati ricerca",
                                            "description": "Restituisce il conteggio totale dei risultati per i parametri di ricerca forniti. Gli eventi vengono contati per le loro occorrenze future (ogni occorrenza = 1 slot).",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "search_type",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["text", "filters", "default"], "default": "filters"},
                                                },
                                                {
                                                    "name": "search_text",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "filter_item_type",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["all", "exhibition", "event", "museum"], "default": "all"},
                                                },
                                                {
                                                    "name": "filter_province",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "filter_region",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "id_athena",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "filter_exhibition_am_option",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["all", "by_subscription", "on_sale"]},
                                                },
                                                {
                                                    "name": "filter_exhibition_time",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["ongoing", "future"]},
                                                },
                                                {
                                                    "name": "filter_event_am_option",
                                                    "in": "query",
                                                    "schema": {"type": "string", "enum": ["all", "am_club", "am_family"]},
                                                },
                                                {
                                                    "name": "filter_event_time",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "filter_museum_am_option",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                },
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore, slug con trattino o id_prodotto Netcaring. Vedi /am/eventi/{id} per i valori accettati.",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Conteggio risultati",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "count": {"type": "integer"},
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/homepage/featured-items": {
                                        "get": {
                                            "tags": ["homepage"],
                                            "summary": "Items in evidenza per homepage",
                                            "description": "Restituisce gli item in evidenza ordinati per ranking (configurazione AppMobile)",
                                            "security": [{"ApiKeyAuth": []}],
                                            "responses": {
                                                "200": {
                                                    "description": "Items in evidenza",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "oneOf": [
                                                                                {"$ref": "#/components/schemas/Mostra"},
                                                                                {"$ref": "#/components/schemas/Evento"},
                                                                                {"$ref": "#/components/schemas/Notizia"},
                                                                                {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                                                {"$ref": "#/components/schemas/Page"},
                                                                            ],
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/homepage/featured-museums": {
                                        "get": {
                                            "tags": ["homepage"],
                                            "summary": "Musei in evidenza per homepage",
                                            "description": "Restituisce 8 musei in evidenza. Se lat/lng forniti, ordina per distanza. Altrimenti, selezione randomizzata per regione basata su subscription_type.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore, slug con trattino o id_prodotto Netcaring (default: tessera_extra). Vedi /am/eventi/{id} per i valori accettati.",
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Musei in evidenza",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/homepage/featured-exhibitions": {
                                        "get": {
                                            "tags": ["homepage"],
                                            "summary": "Mostre in evidenza per homepage",
                                            "description": "Restituisce mostre temporanee in evidenza per regione, ordinate per prossimità temporale rispetto a oggi.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore, slug con trattino o id_prodotto Netcaring (default: tessera_extra). Vedi /am/eventi/{id} per i valori accettati.",
                                                },
                                                {
                                                    "name": "lat",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                                {
                                                    "name": "lng",
                                                    "in": "query",
                                                    "schema": {"type": "number"},
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Mostre in evidenza",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Mostra"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/homepage/featured-events": {
                                        "get": {
                                            "tags": ["homepage"],
                                            "summary": "Eventi in evidenza per homepage",
                                            "description": "Restituisce eventi futuri in evidenza per regione, ordinati per data_evento crescente.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore, slug con trattino o id_prodotto Netcaring (default: tessera_extra). Vedi /am/eventi/{id} per i valori accettati.",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Eventi in evidenza",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Evento"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                    "/am/homepage/news": {
                                        "get": {
                                            "tags": ["homepage"],
                                            "summary": "Notizie in evidenza per homepage",
                                            "description": "Restituisce notizie in evidenza valide (validità >= oggi) ordinate per data pubblicazione decrescente.",
                                            "security": [{"ApiKeyAuth": []}],
                                            "parameters": [
                                                {
                                                    "name": "subscription_type",
                                                    "in": "query",
                                                    "schema": {"type": "string"},
                                                    "description": "Tipo abbonamento: slug con underscore, slug con trattino o id_prodotto Netcaring (default: tessera_extra). Vedi /am/eventi/{id} per i valori accettati.",
                                                },
                                            ],
                                            "responses": {
                                                "200": {
                                                    "description": "Notizie in evidenza",
                                                    "content": {
                                                        "application/json": {
                                                            "schema": {
                                                                "type": "object",
                                                                "properties": {
                                                                    "results": {
                                                                        "type": "array",
                                                                        "items": {"$ref": "#/components/schemas/Notizia"},
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                "400": {"$ref": "#/components/responses/BadRequest"},
                                                "401": {"$ref": "#/components/responses/Unauthorized"},
                                            },
                                        },
                                    },
                                },
                                "components": {
                                    "securitySchemes": {
                                        "ApiKeyAuth": {
                                            "type": "apiKey",
                                            "in": "header",
                                            "name": "X-Access-Token",
                                            "description": "Chiave API per autenticazione. Può essere fornita anche come 'am-api-token' (case-insensitive).",
                                        },
                                    },
                                    "schemas": {
                                        "Notizia": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "wp_modified": {"type": "string", "format": "date-time"},
                                                "wp_date": {"type": "string", "format": "date-time"},
                                                "title": {"type": "string"},
                                                "description": {"type": "string", "description": "HTML content"},
                                                "link": {"type": "string", "format": "uri"},
                                                "validita": {"type": "string", "format": "date", "description": "Data validità (YYYYMMDD)"},
                                                "item_type": {"type": "string", "example": "notizia"},
                                                "featuredMedia": {"$ref": "#/components/schemas/FeaturedMedia"},
                                                "mostra": {"$ref": "#/components/schemas/Mostra"},
                                                "spazioEspositivo": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                "luogoSpettacolo": {"$ref": "#/components/schemas/LuogoSpettacolo"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "Evento": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "wp_modified": {"type": "string", "format": "date-time"},
                                                "wp_date": {"type": "string", "format": "date-time"},
                                                "title": {"type": "string"},
                                                "description": {"type": "string"},
                                                "info": {"type": "string"},
                                                "link": {"type": "string", "format": "uri"},
                                                "item_type": {"type": "string", "example": "evento"},
                                                "indirizzo": {"type": "string"},
                                                "cap": {"type": "string"},
                                                "comune": {"type": "string"},
                                                "provincia": {"type": "string"},
                                                "regione": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                "data_evento": {"type": "string", "format": "date", "description": "Prossima data evento (YYYYMMDD)"},
                                                "orari": {
                                                    "type": "array",
                                                    "items": {"type": "string"},
                                                    "description": "DEPRECATED: Array di orari HH:MM",
                                                },
                                                "ora_evento": {"type": "string", "description": "DEPRECATED: Orari separati da |"},
                                                "date_evento": {
                                                    "type": "array",
                                                    "items": {"$ref": "#/components/schemas/GiornoEvento"},
                                                    "description": "Tutte le occorrenze future dell'evento",
                                                },
                                                "amclub": {"type": "boolean"},
                                                "amfamily": {"type": "boolean"},
                                                "link_prenota": {"type": "string", "format": "uri"},
                                                "testo_prenota": {"type": "string"},
                                                "punti_obj": {
                                                    "type": "array",
                                                    "items": {"type": "object"},
                                                    "description": "Configurazione punti loyalty associati all'evento",
                                                },
                                                "featuredMedia": {"$ref": "#/components/schemas/FeaturedMedia"},
                                                "spazioEspositivo": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                "luogoSpettacolo": {"$ref": "#/components/schemas/LuogoSpettacolo"},
                                                "mostra": {"$ref": "#/components/schemas/Mostra"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "GiornoEvento": {
                                            "type": "object",
                                            "description": "Singola occorrenza di un evento",
                                            "properties": {
                                                "data_evento": {"type": "string", "format": "date", "description": "Data occorrenza (YYYYMMDD)"},
                                                "orari_da_a": {
                                                    "type": "array",
                                                    "items": {"type": "string"},
                                                    "description": "Orari da-a per questa occorrenza",
                                                },
                                            },
                                        },
                                        "Mostra": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "wp_modified": {"type": "string", "format": "date-time"},
                                                "wp_date": {"type": "string", "format": "date-time"},
                                                "title": {"type": "string"},
                                                "description": {"type": "string"},
                                                "link": {"type": "string", "format": "uri"},
                                                "tipologia": {"type": "string", "enum": ["permanente", "temporanea"]},
                                                "item_type": {"type": "string", "example": "mostra"},
                                                "data_inizio": {"type": "string", "format": "date", "description": "YYYYMMDD"},
                                                "data_fine": {"type": "string", "format": "date", "description": "YYYYMMDD"},
                                                "scopri_di_piu": {"type": "string"},
                                                "orari": {"type": "string", "description": "Orari settimanali con formato libero"},
                                                "aperture_chiusure_straordinarie": {"type": "string"},
                                                "in_abbonamento": {"type": "boolean", "description": "Presente solo se fornito subscription_type"},
                                                "in_sconto": {"type": "boolean", "description": "Presente solo se fornito subscription_type"},
                                                "abbonamento": {"type": "string", "description": "Descrizione vantaggio per utente. Presente solo se fornito subscription_type"},
                                                "tessera_piemonte_vda": {"type": "string", "enum": ["gratuito", "scontato"], "description": "Trattamento della mostra con tessera Piemonte/VdA. Rimosso dalle risposte dei dettagli per evitare di esporre la logica lato client"},
                                                "tessera_extra": {"type": "string", "enum": ["gratuito", "scontato"], "description": "Trattamento della mostra con tessera Extra"},
                                                "codice_bpoint": {"type": "string", "description": "Codice BPoint dello spazio espositivo (denormalizzato dalla Mostra)"},
                                                "id_agenzia_athena": {"type": "integer", "description": "ID agenzia Athena dello spazio espositivo (denormalizzato)"},
                                                "orari_specifici": {"type": "boolean", "description": "Indica se gli orari della mostra differiscono da quelli dello spazio espositivo"},
                                                "punti_obj": {"type": "array", "items": {"type": "object"}, "description": "Configurazione punti loyalty associati alla mostra"},
                                                "wp_featured_media": {"type": "integer", "description": "WP ID della featured media associata"},
                                                "wp_id_spazio_espositivo": {"type": "integer", "description": "WP ID dello spazio espositivo di riferimento"},
                                                "featuredMedia": {"$ref": "#/components/schemas/FeaturedMedia"},
                                                "spazioEspositivo": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "SpazioEspositivo": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "wp_modified": {"type": "string", "format": "date-time"},
                                                "wp_date": {"type": "string", "format": "date-time"},
                                                "title": {"type": "string"},
                                                "description": {"type": "string"},
                                                "link": {"type": "string", "format": "uri"},
                                                "item_type": {"type": "string", "example": "spazio_espositivo"},
                                                "indirizzo": {"type": "string"},
                                                "cap": {"type": "string"},
                                                "comune": {"type": "string"},
                                                "provincia": {"type": "string"},
                                                "regione": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                "lat": {"type": "number", "format": "double"},
                                                "lng": {"type": "number", "format": "double"},
                                                "telefono": {"type": "string"},
                                                "sito_web": {"type": "string", "format": "uri"},
                                                "codice_bpoint": {"type": "string"},
                                                "id_agenzia_athena": {"type": "integer"},
                                                "fuori_circuito": {"type": "boolean"},
                                                "orari": {"type": "string"},
                                                "aperture_chiusure_straordinarie": {"type": "string"},
                                                "categorie": {
                                                    "type": "array",
                                                    "items": {"$ref": "#/components/schemas/Categoria"},
                                                },
                                                "categories": {
                                                    "type": "array",
                                                    "items": {"type": "string"},
                                                    "description": "Array di label categorie",
                                                },
                                                "wp_id_categories": {
                                                    "type": "array",
                                                    "items": {"type": "integer"},
                                                    "description": "WordPress ID delle categorie associate",
                                                },
                                                "servizi_accessibilita_concatenati": {
                                                    "type": "string",
                                                    "description": "Servizi accessibilità come stringa concatenata nel formato `key::descrizione||key::descrizione`. Le chiavi sono quelle elencate sopra (es. museo_accessibile, mezzi_pubblici...)",
                                                },
                                                "servizi_infanzia_concatenati": {
                                                    "type": "string",
                                                    "description": "Servizi infanzia come stringa concatenata nel formato `key::descrizione||key::descrizione`",
                                                },
                                                "bgbs23": {
                                                    "type": "boolean",
                                                    "description": "Flag iniziativa BGBS 2023 (Bergamo Brescia Capitale della Cultura)",
                                                },
                                                "mostra": {"$ref": "#/components/schemas/Mostra"},
                                                "featuredMedia": {"$ref": "#/components/schemas/FeaturedMedia"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "LuogoSpettacolo": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "wp_modified": {"type": "string", "format": "date-time"},
                                                "wp_date": {"type": "string", "format": "date-time"},
                                                "title": {"type": "string"},
                                                "description": {"type": "string"},
                                                "link": {"type": "string", "format": "uri"},
                                                "item_type": {"type": "string", "example": "luogo_spettacolo"},
                                                "indirizzo": {"type": "string"},
                                                "cap": {"type": "string"},
                                                "comune": {"type": "string"},
                                                "provincia": {"type": "string"},
                                                "regione": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                                "lat": {"type": "number", "format": "double"},
                                                "lng": {"type": "number", "format": "double"},
                                                "telefono": {"type": "string"},
                                                "sito_web": {"type": "string", "format": "uri"},
                                                "categorie": {
                                                    "type": "array",
                                                    "items": {"$ref": "#/components/schemas/Categoria"},
                                                },
                                                "categories": {
                                                    "type": "array",
                                                    "items": {"type": "string"},
                                                },
                                                "featuredMedia": {"$ref": "#/components/schemas/FeaturedMedia"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "FeaturedMedia": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "wp_modified": {"type": "string", "format": "date-time"},
                                                "wp_date": {"type": "string", "format": "date-time"},
                                                "link": {"type": "string", "format": "uri"},
                                                "image_full": {"type": "string", "format": "uri"},
                                                "image_medium": {"type": "string", "format": "uri"},
                                                "image_thumbnail": {"type": "string", "format": "uri"},
                                                "image_large": {"type": "string", "format": "uri"},
                                                "mime_type": {"type": "string"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "Categoria": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "label": {"type": "string"},
                                                "slug": {"type": "string"},
                                                "link": {"type": "string", "format": "uri"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "Provincia": {
                                            "type": "object",
                                            "properties": {
                                                "name": {"type": "string"},
                                                "label": {"type": "string"},
                                                "regione": {"type": "string", "enum": ["piemonte", "lombardia", "valle-aosta"]},
                                            },
                                        },
                                        "PuntoVendita": {
                                            "type": "object",
                                            "properties": {
                                                "wp_id": {"type": "integer"},
                                                "title": {"type": "string"},
                                                "indirizzo": {"type": "string"},
                                                "cap": {"type": "string"},
                                                "comune": {"type": "string"},
                                                "provincia": {"type": "string"},
                                                "regione": {"type": "string"},
                                                "lat": {"type": "number", "format": "double"},
                                                "lng": {"type": "number", "format": "double"},
                                                "spazioEspositivo": {"$ref": "#/components/schemas/SpazioEspositivo"},
                                                "createdAt": {"type": "string", "format": "date-time"},
                                                "updatedAt": {"type": "string", "format": "date-time"},
                                            },
                                        },
                                        "Page": {
                                            "type": "object",
                                            "properties": {
                                                "title": {"type": "string"},
                                                "item_type": {"type": "string", "example": "page"},
                                                "link": {"type": "string", "format": "uri"},
                                                "featuredMedia": {"$ref": "#/components/schemas/FeaturedMedia"},
                                            },
                                        },
                                        "Error": {
                                            "type": "object",
                                            "properties": {
                                                "code": {"type": "integer"},
                                                "message": {"type": "string"},
                                            },
                                            "required": ["code", "message"],
                                        },
                                    },
                                    "responses": {
                                        "NotFound": {
                                            "description": "Risorsa non trovata",
                                            "content": {
                                                "application/json": {
                                                    "schema": {"$ref": "#/components/schemas/Error"},
                                                    "example": {"code": 404, "message": "Not Found"},
                                                },
                                            },
                                        },
                                        "Unauthorized": {
                                            "description": "Non autorizzato",
                                            "content": {
                                                "application/json": {
                                                    "schema": {"$ref": "#/components/schemas/Error"},
                                                    "example": {"code": 401, "message": "Unauthorized"},
                                                },
                                            },
                                        },
                                        "BadRequest": {
                                            "description": "Richiesta non valida",
                                            "content": {
                                                "application/json": {
                                                    "schema": {"$ref": "#/components/schemas/Error"},
                                                    "example": {"code": 400, "message": "Bad Request"},
                                                },
                                            },
                                        },
                                    },
                                },
                            }}
                />
            );

export default App;